import React, { useState, useEffect } from 'react';
import {
  Widget,
  MasterDetailForm,
  Row,
  InlineEditColumnProps,
  Table,
  Button,
} from '@digital/ui';
import { Collapse, Icon } from 'antd';
import { ContratadoRequisicaoCompraMaterial } from '@app/api/projeto';

interface FormResumoContratadoProps {
  contratadoRequisicaoCompraMaterial: ContratadoRequisicaoCompraMaterial[];
  style: any;
}

const { Panel } = Collapse;

const FormTableContratadoRequisicaoCompraMaterial = (props: FormResumoContratadoProps) => {
  const { contratadoRequisicaoCompraMaterial, style } = props;

  const [valorTotal, setValorTotal] = useState<string>();

  useEffect(() => {
    const getData = () => {
      if (contratadoRequisicaoCompraMaterial.length > 0) {
        var requisitado = contratadoRequisicaoCompraMaterial[contratadoRequisicaoCompraMaterial.length - 1];
        if (requisitado) {
          setValorTotal(requisitado.distribuidoTotalFormatado);
        }
      }
    };

    getData();
  }, [contratadoRequisicaoCompraMaterial]);

  const customColumns = () => {
    return [
      {
        title: 'N',
        dataIndex: 'index',
        width: '1%',
      },

      {
        title: 'RC',
        dataIndex: 'contratadoCompraNumero',
        width: '2%',
      },
      {
        title: 'RC Seq',
        dataIndex: 'contratadoCompraSeq',
        width: '13%',
      },
      {
        title: 'Narrativa',
        dataIndex: 'narrativa',
        width: '35%',
      },
      {
        title: 'Valor total',
        dataIndex: 'requisicaoCompraValorTotalFormatado',
        width: '35%',
      },
      {
        title: 'No Projeto',
        dataIndex: 'valorDistribuidoFormatado',
        key: 'valorTotalCurrency',
        children: [
          {
            title: `${valorTotal || ''}`,
            dataIndex: 'valorDistribuidoFormatado',
            width: '1%',
          },
        ],
      },
      {
        title: 'Valor à distribuir',
        dataIndex: 'valorParaDistribuidoFormatado',
        width: '35%',
      },
      {
        title: 'OC',
        dataIndex: 'contratadoCompraOc',
        width: '35%',
      },
      {
        title: 'PCM',
        dataIndex: 'pedidoPcm',
        width: '35%',
      },
    ] as InlineEditColumnProps<ContratadoRequisicaoCompraMaterial>[];
  };

  return (
    <>
      <Collapse
        bordered={false}
        defaultActiveKey={['2']}
        expandIcon={() => <Icon type="arrows-right_4" />}
        style={style}>
        <Panel key="2" header="ITENS DE REQUISIÇÃO DE COMPRA DE MATERIAL" style={{ border: 0 }}>
          <MasterDetailForm>
            <Widget
              actions={[
                <Button
                  title="Distribuir contratado material"
                  type="primary"
                  icon="commons-search"
                  onClick={() => {
                    window.location.href = `/Cr/moduloContratado/pedidoMaterial`;
                  }}
                />,
              ]}>
              <Row>
                <Table
                  rowKey="index"
                  columns={customColumns()}
                  dataSource={contratadoRequisicaoCompraMaterial}

                />
              </Row>
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
    </>
  );
};

export default FormTableContratadoRequisicaoCompraMaterial;
